import * as types from '@types'
import * as services from '@services/location'
import { cepSearch } from '@/modules/input/cepFill'

export default {
  state: {
    states: [],
    citiesList: [],
    cities: {}
  },

  getters: {
    getState: (state) => stateId =>
      state.states.find(({ id }) => id === stateId) || {},

    getCities: (state) => stateId => {
      const { abbreviation } = state.states.find(({ id }) => id === stateId) || {}

      return state.cities[abbreviation] || []
    }
  },

  mutations: {
    [types.LOCATION_CITIES]: (state, data) => {
      state.citiesList = [ ...data?.cities || [] ]

      const { abbreviation } = state.states.find(({ id }) => id === data.state) || {}

      if (!abbreviation) return

      state.cities = {
        ...state.cities,
        [abbreviation]: data.cities
      }
    }
  },

  actions: {
    [types.LOCATION_CITIES]: async ({ commit, getters }, stateId) => {
      const companyId = getters.getCompanyUuid
      const cities = getters.getCities(stateId)

      if (cities.length) return cities

      const [ err, data ] = await services.getCities({ stateId, companyId })

      if (!err) commit(types.LOCATION_CITIES, { state: stateId, cities: data })

      return data
    },

    [types.LOCATION_GET_CEP_ADDRESS]: async (_, cep) => {
      const cepAddress = await cepSearch(cep)

      return [ false, cepAddress ]
    }
  }
}
